var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOriginalUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10671 7.24536C6.04004 7.2387 5.96004 7.2387 5.88671 7.24536C4.30004 7.19203 3.04004 5.89203 3.04004 4.29203C3.04004 2.6587 4.36004 1.33203 6.00004 1.33203C7.63337 1.33203 8.96004 2.6587 8.96004 4.29203C8.95337 5.89203 7.69337 7.19203 6.10671 7.24536Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9402 2.66797C12.2335 2.66797 13.2735 3.71464 13.2735 5.0013C13.2735 6.2613 12.2735 7.28797 11.0268 7.33464C10.9735 7.32797 10.9135 7.32797 10.8535 7.33464",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77348 9.70797C1.16014 10.788 1.16014 12.548 2.77348 13.6213C4.60681 14.848 7.61348 14.848 9.44681 13.6213C11.0601 12.5413 11.0601 10.7813 9.44681 9.70797C7.62014 8.48797 4.61348 8.48797 2.77348 9.70797Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 13.332C12.7066 13.232 13.1599 13.0387 13.5332 12.752C14.5732 11.972 14.5732 10.6854 13.5332 9.90536C13.1666 9.62536 12.7199 9.4387 12.2466 9.33203",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalUsers);
export default __webpack_public_path__ + "static/media/original-users.5114165be7734b5d36312afca663458c.svg";
export { ForwardRef as ReactComponent };